export default {
  from: {
    freebe: 'freebe',
    partner: 'partner',
    growth: 'growth',
  },

  type: {
    percent: '%',
    percentage: '%',

    month: 'months',
    months: 'months',
    
    year: 'years',
    years: 'years',
  },

  sponsorshipReduction: 'sponsorship',
}